import request from "../helpers/request";
import { AuthHeader } from "../helpers";

export {
  editMeasurement,
  getMeasurements,
  getMeasurementById,
  getMealCategories,
  getWasteTypes,
  deleteMeasurementById,
  getMeasurementsByCustomerId,
  getMeasurementsByLocationId,
  exportMeasurementToCsv,
  exportAllMeasurementsToCsv,
};

function editMeasurement(
  residentsPresent,
  components,
  employee,
  date,
  measurementId
) {
  return request({
    url: "measurements/update/" + measurementId,
    method: "PUT",
    data: {
      residents_present: residentsPresent,
      date: date,
      employee: employee,
      components: components,
    },
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getMeasurements() {
  return request({
    url: "measurements/",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getMeasurementsByCustomerId(customerId) {
  return request({
    url: "measurements/filter/" + customerId,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getMeasurementsByLocationId(customerId, locationId) {
  return request({
    url: "measurements/filter/" + customerId + "/" + locationId,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getMeasurementById(measurementId) {
  return request({
    url: "measurements/" + measurementId,
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function deleteMeasurementById(measurementId) {
  return request({
    url: "measurements/delete/" + measurementId,
    method: "DELETE",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getWasteTypes() {
  return request({
    url: "waste-types/admin",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function getMealCategories() {
  return request({
    url: "meal-categories/admin",
    method: "GET",
    headers: AuthHeader(),
  }).then((res) => {
    return res;
  });
}

function exportMeasurementToCsv(measurementId) {
  return request({
    url: `measurements/${measurementId}/export`,
    method: 'GET',
    headers: AuthHeader()
  }).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', "export.csv")
    document.body.appendChild(link)
    link.click()
    link.remove()
  })
}

function exportAllMeasurementsToCsv(departmentId) {
  return request({
    url: `measurements/export-department/${departmentId}`,
    method: 'GET',
    headers: AuthHeader()
  }).then((res) => {
    const url = window.URL.createObjectURL(new Blob([res]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', "export.csv")
    document.body.appendChild(link)
    link.click()
    link.remove()
  })
}
